import { Box, useTheme } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMeetStore } from "src/stores/meetStore";
import MeetDrawer from "../meet/MeetDrawer";
import MinimalHeader from "../menu/MinimalHeader";

/** Background shared with MeetListPage so the list never shows a white footer band. */
const LIST_PAGE_BG = "#f5f5f5";

// Composant qui gère le layout minimal avec header simplifié et drawer
interface MinimalLayoutProps {
  children: ReactNode;
}

export default function MinimalLayout({ children }: MinimalLayoutProps) {
  const theme = useTheme();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { id } = useParams();
  const { getMeetWithAll, fetchMeetWithAll } = useMeetStore();
  const currentMeet = id ? getMeetWithAll(id) : undefined;
  const isMeetListRoute = !id;

  useEffect(() => {
    if (id) {
      fetchMeetWithAll(id);
    }
  }, [id, fetchMeetWithAll]);

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100svh",
        bgcolor: isMeetListRoute ? LIST_PAGE_BG : "background.default",
      }}
    >
      <MinimalHeader
        onDrawerToggle={handleDrawerToggle}
        isDrawerOpen={isDrawerOpen}
      />
      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          pt: `${theme.spacing(6)}`,
          bgcolor: isMeetListRoute ? LIST_PAGE_BG : undefined,
          // Detail routes keep a full-height main; list fills via flex + matching bgcolor
          ...(id
            ? {
                "& > *": {
                  minHeight: `calc(100svh - ${theme.spacing(6)})`,
                },
              }
            : {
                "& > *": {
                  flex: 1,
                },
              }),
        }}
      >
        {children}
      </Box>
      {/* Afficher le drawer uniquement si nous avons un meet actif */}
      {currentMeet && (
        <MeetDrawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          meet={currentMeet}
        />
      )}
    </Box>
  );
}
